module.exports = __webpack_public_path__ + "static/media/ML_Relief_Catcher.5a548d1b.png";